import React from 'react';
import '../styles/LegalPages.css';

function PrivacyPolicy() {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <h1>Privacy Policy</h1>
        <p className="legal-updated">Last updated: November 12, 2025</p>

        <section className="legal-section">
          <h2>Introduction</h2>
          <p>
            Certifiable is a personal project operated by an independent developer based in Sweden. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our certificate management application during the beta testing period.
          </p>
        </section>

        <section className="legal-section">
          <h2>Information We Collect</h2>
          <h3>Personal Information</h3>
          <p>When you create an account, we collect:</p>
          <ul>
            <li>Name and email address</li>
            <li>Account credentials</li>
            <li>Profile information you choose to provide</li>
          </ul>

          <h3>Certificate Data</h3>
          <p>When you use our service, we store:</p>
          <ul>
            <li>Certificate names, types, and descriptions</li>
            <li>Issue and expiry dates</li>
            <li>Uploaded certificate files and images</li>
            <li>Any additional notes or metadata you add</li>
          </ul>

          <h3>Usage Information</h3>
          <p>We automatically collect:</p>
          <ul>
            <li>Browser type and version</li>
            <li>Device information</li>
            <li>IP address and location data</li>
            <li>Usage patterns and feature interactions</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>How We Use Your Information</h2>
          <p>We use your information to:</p>
          <ul>
            <li>Provide and maintain the Certifiable service</li>
            <li>Send expiry reminder notifications</li>
            <li>Facilitate certificate sharing with employers</li>
            <li>Improve and optimize our application</li>
            <li>Communicate with you about updates and support</li>
            <li>Ensure security and prevent fraud</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>Data Storage and Security</h2>
          <p>
            Your data is stored securely on cloud infrastructure with industry-standard encryption. Certificate files are stored in secure cloud storage (Cloudflare R2). We implement appropriate technical and organizational measures to protect your personal information.
          </p>
          <p>
            Uploaded certificates may contain personal information such as your name, date of birth, or qualification details. By uploading these documents, you acknowledge that you have the right to share them and understand that they will be stored securely for your personal record-keeping. Certifiable does not verify or process the contents of certificates beyond basic metadata extraction.
          </p>
        </section>

        <section className="legal-section">
          <h2>Data Sharing and Disclosure</h2>
          <p>We do not sell your personal information. We may share your data only in these circumstances:</p>
          <ul>
            <li><strong>With your consent:</strong> When you choose to share certificates via email</li>
            <li><strong>Service providers:</strong> Third-party services that help us operate (e.g., email delivery, cloud hosting)</li>
            <li><strong>Legal requirements:</strong> When required by law or to protect our rights</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>Your Rights</h2>
          <p>You have the right to:</p>
          <ul>
            <li>Access and download your data</li>
            <li>Correct inaccurate information</li>
            <li>Delete your account and associated data</li>
            <li>Object to processing of your data</li>
            <li>Withdraw consent at any time</li>
          </ul>
          <p>To exercise these rights, contact us at romijade@gmail.com</p>
        </section>

        <section className="legal-section">
          <h2>Data Retention</h2>
          <p>
            We retain your information for as long as your account is active or as needed to provide services. If you delete your account, we will delete your personal data within 30 days, except where retention is required by law.
          </p>
        </section>

        <section className="legal-section">
          <h2>Cookies and Tracking</h2>
          <p>
            We use cookies and similar technologies to maintain your session and improve your experience.
          </p>
          
          <h3>Essential Cookies</h3>
          <p>
            These cookies are necessary for the website to function and cannot be switched off:
          </p>
          <ul>
            <li><strong>Authentication cookies:</strong> Keep you logged in securely</li>
            <li><strong>Session cookies:</strong> Remember your preferences during your visit</li>
          </ul>

          <h3>Analytics Cookies</h3>
          <p>
            With your consent, we use analytics cookies to understand how visitors use our site:
          </p>
          <ul>
            <li><strong>Google Analytics:</strong> Tracks page views, user interactions, and traffic sources</li>
            <li><strong>Usage data:</strong> Helps us improve features and user experience</li>
          </ul>
          <p>
            You can accept or reject analytics cookies through the cookie banner. Your choice is saved in your browser. Essential cookies remain active regardless of your choice.
          </p>

          <h3>Managing Cookies</h3>
          <p>
            You can control cookies through your browser settings and our cookie banner. To change your cookie preferences, clear your browser's local storage for this site and refresh the page to see the banner again.
          </p>
        </section>

        <section className="legal-section">
          <h2>Children's Privacy</h2>
          <p>
            Certifiable is not intended for users under 18 years of age. We do not knowingly collect personal information from children.
          </p>
        </section>

        <section className="legal-section">
          <h2>International Data Transfers</h2>
          <p>
            Your information may be transferred to and processed in countries other than your own. We ensure appropriate safeguards are in place to protect your data.
          </p>
        </section>

        <section className="legal-section">
          <h2>Changes to This Policy</h2>
          <p>
            We may update this Privacy Policy from time to time. We will notify you of significant changes by email or through the application.
          </p>
        </section>

        <section className="legal-section">
          <h2>Contact Us</h2>
          <p>
            If you have questions about this Privacy Policy or wish to exercise your data rights, please contact us at:
          </p>
          <p>
            Email: <a href="mailto:romijade@gmail.com">romijade@gmail.com</a>
          </p>
          <p>
            Certifiable is a personal project operated by an independent developer based in Sweden.
          </p>
        </section>

        <div className="legal-footer">
          <a href="/">← Back to Home</a>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
